import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import StockLevelField from "../StockLevelField.js";
import ActionField from "../ActionField.js";
import NotifySection from "../NotifySection/NotifySection.js";
import { Field } from "react-final-form";
import {
  PRODUCTS_ACTION_HIDE,
  PRODUCTS_ACTION_PUSH_DOWN,
  PRODUCTS_NO_ACTION
} from "../../../../../../../../../constants/productActionTypes.js";

const actionOptions = [
  { label: "Hide out of stock", value: PRODUCTS_ACTION_HIDE },
  { label: "Push down out of stock", value: PRODUCTS_ACTION_PUSH_DOWN },
  { label: "No action", value: PRODUCTS_NO_ACTION }
];

const OutOfStockCard = () => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack distribution={"fill"} vertical>
            <Field name="outStockLevel" component={StockLevelField} prefix="Less than" label="Stock level" />
            <Field name="outStockAction" component={ActionField} options={actionOptions} />
            <Field name="outStockNotify" component={NotifySection} />
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default OutOfStockCard;